import React from 'react';
import { Spinner } from './NavIcons';
import { useDeliverySlots } from '../deliverySlots';
import { isAfterTodayCutoff } from '../utils/deliveryDates';
import { nowInTZ } from '../utils/timezone';

// Блок «Сейчас нет в продаже» / «Такой страницы нет» наверху каталога (ТЗ «реклама по
// наличию», В1–В3; вариант B дизайн-разбора 29.10.2026).
//
// Человек пришёл по ссылке на позицию, которой сейчас не купить (скрыта, продана, в архиве),
// на неверный адрес или в пустую подборку. Он попадает в обычный каталог — шапка, разделы,
// меню и корзина на месте, — а сверху мягкий блок: фото и название, что случилось, лента
// «Есть сегодня» (обычные карточки каталога в режиме compact, листается вбок; их передаёт
// каталог: children). Под блоком — раздел этой позиции, в том числе то, что приедет позже.
// «×» убирает блок. Окна поверх окна, своей «Назад» и своей корзины больше нет.
function UnavailableNotice({ status, name = null, image = null, note = null, loading = false, children = null, onClose, noticeRef = null }) {
  const slots = useDeliverySlots();
  // После отсечки приёма на сегодня то, что лежит на складе, можно заказать уже на завтра
  const afterCutoff = !!(slots.loaded && slots.shopTimezone
    && isAfterTodayCutoff(nowInTZ(slots.shopTimezone), slots.timeSlots, slots.leadTimeMinutes));
  const hasSimilar = React.Children.toArray(children).length > 0;

  return (
    <section className="unavail-notice" ref={noticeRef} aria-labelledby="unavail-title">
      <div className="unavail-head">
        {image && <img className="unavail-photo" src={image} alt="" decoding="async" />}
        <div className="unavail-text">
          <div id="unavail-title" className="unavail-name">{name || status}</div>
          {name ? <div className="unavail-status">{status}</div>
            : note && <div className="unavail-status">{note}</div>}
        </div>
        <button className="unavail-close" onClick={onClose} aria-label="Убрать">×</button>
      </div>

      {loading && !hasSimilar && (
        <div className="unavail-loading"><Spinner size={24} /></div>
      )}
      {hasSimilar && (
        <>
          <h3 className="unavail-subtitle">{afterCutoff ? 'Можно заказать на завтра' : 'Есть сегодня'}</h3>
          <div className="unavail-shelf">{children}</div>
        </>
      )}
    </section>
  );
}

export default UnavailableNotice;
